import { render, staticRenderFns } from "./GoodToKnow.vue?vue&type=template&id=62fa367c&scoped=true&"
import script from "./GoodToKnow.vue?vue&type=script&lang=ts&"
export * from "./GoodToKnow.vue?vue&type=script&lang=ts&"
import style0 from "./GoodToKnow.vue?vue&type=style&index=0&id=62fa367c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa367c",
  null
  
)

export default component.exports